// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1___N","cls2":"FocusedNav-cls2_uD_ FocusedNav-cls1___N"};